<template>
  <div class="text-left bg-white">
    <!-- 地点情報 -->
    <div class="flex">
      <div class="flex-1 min-w-0">
        <div class="text-W7 text-[15px] leading-[15px] truncate mb-1">
          {{ comment.spot.name }}
        </div>
        <div class="text-W4 text-[11px] leading-[11px] truncate text-gray400">
          {{ `${distanceText()}${comment.spot.address}` }}
        </div>
        <!-- サムネイル画像 -->
        <img
          :src="comment.thumbnailImg"
          class="mt-2 rounded-[8px] w-[251px] h-[124px] object-cover"
          @error="thumbnailImgOnError"
        />
      </div>
      <div class="flex-none my-auto ml-2">
        <img src="@/assets/dokoiku/IconRight.svg" class="w-3 h-3" />
      </div>
    </div>
  </div>
</template>
<script>
import {getDistanceText, calcDistance} from '@/utils/utils'

/**
 * カードサイズは、親で設定
 */
const SpotCard = {
  name: 'SpotCard',
  components: {},
  mixins: [],
  emits: [],
  props: {
    /** 投稿情報 */
    comment: {
      type: Object,
      required: false,
    },
    /** 現在地座標 */
    currentPosition: {
      type: Object,
      required: false,
    },
  },
  methods: {
    /**
     * 表示する距離文言
     * @returns 距離の文言
     */
    distanceText() {
      const coord = this.comment.spot.coord
      const targetPoint = {lat: coord.lat, lon: coord.lon}
      // 現在地と地点間の距離を算出(座標データが存在しない、不適切の場合は空文字が返却)
      const distanceM = calcDistance(targetPoint, this.currentPosition)
      if (typeof distanceM == 'undefined') return ''

      // 表示用に加工して返却
      const showDistance = getDistanceText(distanceM)
      return showDistance
    },
    /**
     * サムネイル画像読み込み失敗時処理
     * @param {Event} event イベント情報
     */
    thumbnailImgOnError(event) {
      // 読み込み失敗した場合は、NoImageアイコンを表示する
      const noImageIcon = require('@/assets/NoImage.svg')
      event.target.src = noImageIcon
    },
  },
}
export default SpotCard
</script>
<style scoped></style>
